import { render, staticRenderFns } from "./AttachmentsComponent.vue?vue&type=template&id=57601760&"
import script from "./AttachmentsComponent.vue?vue&type=script&lang=js&"
export * from "./AttachmentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports